// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GHodT","col":"styles_col__3Dgnu"};